module.exports = __webpack_public_path__ + "img/ic-map-minus.3f761e50.svg";